import { style } from "typestyle";

type FontSize = {
  xs: string;
  sm: string;
  base: string;
  lg: string;
  xl: string;
  xl2: string;
  xl3: string;
  xl4: string;
  xl5: string;
};

const fontSize: FontSize = {
  xs: style({ fontSize: "0.8rem", lineHeight: 1.5 }),
  sm: style({ fontSize: "0.875rem", lineHeight: 1.4 }),
  base: style({ fontSize: "1rem", lineHeight: 1.4 }),
  lg: style({ fontSize: "1.125rem", lineHeight: 1.4 }),
  xl: style({ fontSize: "1.25rem", lineHeight: 1.375 }),
  xl2: style({ fontSize: "1.5rem", lineHeight: 1.375 }),
  xl3: style({ fontSize: "1.875rem", lineHeight: 1.375 }),
  xl4: style({ fontSize: "2.25rem", lineHeight: 1.25 }),
  xl5: style({ fontSize: "3rem", lineHeight: 1.1 }),
};

export default fontSize;
